<template>
  <div class="text-right w-100">
    <div class="d-flex text-base bold">
      <span class="ml-2">زمان باقیمانده:</span>
      <client-only>
        <VueCountdown
          ref="countdown"
          :time="question.remindedTime * 1000"
          class="countdown"
          @end="onCountdownEnd"
        >
          <template slot-scope="props">
            <div>
              <p class="gray-700">
                {{ props.hours }}:{{ props.minutes }}:{{ props.seconds }}
              </p>
            </div>
          </template>
        </VueCountdown>
      </client-only>
    </div>
    <div class="page-number__wrapper d-flex flex-wrap w-100 mt-3">
      <div
        v-for="i of question.total"
        :key="i"
        class="page-number m-1"
        :class="{
          'gray-200': question.index < i - 1,
          success: question.index > i - 1,
          primary: question.index === i - 1,
        }"
      >
        {{ i }}
      </div>
    </div>
    <ul class="mt-3">
      <li class="gray-200 mt-2">پاسخ داده نشده</li>
      <li class="success mt-2">پاسخ داده شده</li>
      <li class="primary mt-2">در حال مشاهده</li>
    </ul>
  </div>
</template>

<script>
import VueCountdown from "@chenfengyuan/vue-countdown";

export default {
  components: {
    VueCountdown,
  },
  props: {
    question: {
      type: Object,
    },
  },
  data() {
    return {
      countEnd: false,
    };
  },
  watch: {
    countEnd(val) {
      if (val) this.$emit("finish");
    },
  },
  methods: {
    onCountdownEnd() {
      this.countEnd = true;
    },
  },
};
</script>

<style lang="scss" scoped>
.page-number__wrapper {
  min-width: 100%;
  direction: ltr;
  .page-number {
    width: 32px;
    height: 32px;
    border: 2px solid;
    border-color: inherit;
    text-align: center;
    line-height: 32px;
    border-radius: 4px;
  }
}
</style>
